import React from 'react';
import { EndSpacer } from './EndSpacer';
import { rosterConfig } from '../../roster-config';

const { TIMELINE_CONTENT_GROUP_HEIGHT } = rosterConfig;

interface WorkersTimelineHeaderProps {
  rowWidth: number;
  markers?: React.ReactNode[];
}

export function WorkersTimelineHeader({ rowWidth, markers }: WorkersTimelineHeaderProps) {
  return (
    <div className='flex-row'>
      <div
        className='roster-gray width-full bordered-bottom bordered-top position-relative'
        style={{ height: TIMELINE_CONTENT_GROUP_HEIGHT, minWidth: rowWidth, maxWidth: rowWidth }}
      >
        {markers}
      </div>
      <EndSpacer height={56} />
    </div>
  );
}
